/**
 * Sample Slot Components for PhotoCollection2 Test Page
 *
 * Header and footer slots for testing PhotoCollection2 slot functionality (#102).
 */

import { Button } from '../../components/atoms/Button';
import { Text } from '../../components/atoms/Text';

/**
 * Sample fixed header - toolbar style with controls
 */
export function SampleFixedHeader() {
  return (
    <div className="px-4 py-3 border-b bg-blue-50 dark:bg-blue-950 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium px-2 py-1 rounded bg-blue-200 dark:bg-blue-800 text-blue-800 dark:text-blue-200">
          FIXED HEADER
        </span>
        <Text className="text-sm font-medium">Collection Toolbar</Text>
      </div>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="secondary">Action 1</Button>
        <Button size="sm" variant="secondary">Action 2</Button>
      </div>
    </div>
  );
}

/**
 * Sample scroll header - rich content with description
 */
export function SampleScrollHeader({ photoCount }: { photoCount: number }) {
  return (
    <div className="p-4 rounded-lg bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-xs font-medium px-2 py-1 rounded bg-green-200 dark:bg-green-800 text-green-800 dark:text-green-200">
          SCROLL HEADER
        </span>
      </div>
      <Text className="text-lg font-bold mb-1">Sample Collection Title</Text>
      <Text variant="muted" className="text-sm mb-2">
        This is a description that scrolls with the content. It provides context about the collection
        and can include multiple lines of text.
      </Text>
      <div className="flex gap-4 text-xs text-muted-foreground">
        <span>{photoCount} photos</span>
        <span>•</span>
        <span>Created today</span>
      </div>
    </div>
  );
}

/**
 * Sample scroll footer - end of collection marker
 */
export function SampleScrollFooter({ photoCount }: { photoCount: number }) {
  return (
    <div className="py-6 text-center bg-yellow-50 dark:bg-yellow-950 rounded-lg border border-yellow-200 dark:border-yellow-800">
      <span className="text-xs font-medium px-2 py-1 rounded bg-yellow-200 dark:bg-yellow-800 text-yellow-800 dark:text-yellow-200 mb-2 inline-block">
        SCROLL FOOTER
      </span>
      <Text variant="muted" className="block mt-2">
        End of collection • {photoCount} photos
      </Text>
    </div>
  );
}

/**
 * Sample fixed footer - action bar with selection count
 */
export function SampleFixedFooter({ selectedCount }: { selectedCount: number }) {
  return (
    <div className="px-4 py-3 border-t bg-purple-50 dark:bg-purple-950 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium px-2 py-1 rounded bg-purple-200 dark:bg-purple-800 text-purple-800 dark:text-purple-200">
          FIXED FOOTER
        </span>
        <Text className="text-sm">
          {selectedCount > 0 ? `${selectedCount} selected` : 'No selection'}
        </Text>
      </div>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="secondary">Cancel</Button>
        <Button size="sm" variant="primary" disabled={selectedCount === 0}>
          Apply
        </Button>
      </div>
    </div>
  );
}
